import * as R from "ramda"

type Path = string | number | (string | number)[]
// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type Value = any
// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type Input = any

const set = R.curry((path: Path, value: Value, input: Input) => {
  const pathArr: (string | number)[] = Array.isArray(path) ? path : String(path).split(".")
  const lens = R.lensPath(pathArr)

  return R.set(lens, value, input)
})

export default set
